/* ============================================================
   BRICKIES — nachtraeglich eingehaengte Oberflaeche
   Erzeugt Vergleichsleiste und Merkliste-Herzen im <body>.
   Bewusst per Skript statt in layout/theme.liquid: so bleibt
   das Layout des Themes unangetastet und Theme-Updates laufen
   ohne Merge-Konflikt durch.

   Keine Sticky-Kaufleiste: Horizon bringt mit
   assets/sticky-add-to-cart.js bereits eine variantenbewusste
   Version mit. Eine zweite waere die schlechtere Dublette.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.BRICKIES_CONFIG || {};

  var HEART =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 20s-7-4.4-7-9.3A4.1 4.1 0 0 1 12 8a4.1 4.1 0 0 1 7 2.7c0 4.9-7 9.3-7 9.3z"/></svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function buildCompareBar() {
    if (document.querySelector('.bk-compare-bar')) return;

    var bar = el('div', 'bk-compare-bar');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Set-Vergleich');

    var label = el('span', null, 'Vergleich');
    label.style.cssText = 'font-size:var(--bk-t-sm);white-space:nowrap;';

    var slots = el('div', 'bk-compare-bar__slots');

    var go = el('a', 'bk-compare-bar__go', 'Sets vergleichen');
    go.href = CFG.compareUrl || '/pages/vergleich';
    go.hidden = true;
    go.style.cssText =
      'padding:10px 20px;border-radius:var(--bk-r-sm);background:#f4e9c8;' +
      'color:var(--bk-vitrine);text-decoration:none;font-size:var(--bk-t-sm);' +
      'font-weight:640;white-space:nowrap;';

    bar.appendChild(label);
    bar.appendChild(slots);
    bar.appendChild(go);
    document.body.appendChild(bar);
  }

  // Zieht den Produkt-Handle aus einer Storefront-URL.
  function handleFrom(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Haengt das Merkliste-Herz in jede Produktkachel. Laeuft nach
  // jedem Section-Rerender erneut und prueft auf Doppelung.
  // .bk-card__media ist die eigene Karte, die uebrigen Treffer
  // decken Horizons Kacheln ab.
  function injectFavourites() {
    var cards = document.querySelectorAll('.product-card, [data-product-card]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.querySelector('.bk-fav')) return;

      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFrom(link.getAttribute('href'));
      if (!handle) return;

      var host = card.querySelector('.bk-card__media')
        || card.querySelector('.card-gallery')
        || card.querySelector('.product-card__image')
        || card;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

      var btn = el('button', 'bk-fav', HEART);
      btn.type = 'button';
      btn.dataset.handle = handle;
      btn.setAttribute('aria-label', 'Auf die Merkliste setzen');
      host.appendChild(btn);
    });
  }

  function run() {
    buildCompareBar();
    injectFavourites();
    if (window.BRICKIES && window.BRICKIES.mount) window.BRICKIES.mount(document);
  }

  function start() {
    run();

    // Horizon rendert Listen per Fetch neu – neue Kacheln nachruesten.
    // Der Beobachter darf sich nicht selbst ausloesen: injectFavourites
    // fuegt Knoten ein, deshalb rAF-Sperre und takeRecords danach.
    var scheduled = false;
    var working = false;

    var observer = new MutationObserver(function () {
      if (working || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        working = true;
        try {
          injectFavourites();
        } finally {
          window.requestAnimationFrame(function () {
            observer.takeRecords();
            working = false;
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
